import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, getFormValues } from 'redux-form';

import ContentCard from '../common/template/contentCard';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import Select from '../common/form/select';

import {
    setModoTela,
    initForm
} from './usuarioPerfilActions';

const listaPermissaoCadastro = [
    {
        id: 'VISUALIZACAO',
        valor: 'Visualizar'
    },
    {
        id: 'VISUALIZACAO,INCLUSAO',
        valor: 'Visualizar e Incluir'
    },
    {
        id: 'VISUALIZACAO,ALTERACAO',
        valor: 'Visualizar e Alterar'
    },
    {
        id: 'VISUALIZACAO,INCLUSAO,ALTERACAO',
        valor: 'Visualizar, Incluir e Alterar'
    },
    {
        id: 'VISUALIZACAO,INCLUSAO,ALTERACAO,EXCLUSAO',
        valor: 'Visualizar, Incluir, Alterar e Excluir'
    }
];

const listaSomenteVisualizacao = [
    {
        id: 'VISUALIZACAO',
        valor: 'Visualizar'
    }
];

const permissoesCadastro = [
    {
        campo: 'cadastro_perfil',
        label: 'Perfil'
    },
    {
        campo: 'cadastro_usuario',
        label: 'Usuário'
    },
    {
        campo: 'cadastro_fornecedor',
        label: 'Fornecedor'
    },
    {
        campo: 'cadastro_cliente',
        label: 'Cliente'
    },
    {
        campo: 'cadastro_unidade_medida',
        label: 'Unidade de Medida'
    },
    {
        campo: 'cadastro_produto',
        label: 'Produto'
    },
    {
        campo: 'cadastro_veiculo',
        label: 'Veículo'
    },
    {
        campo: 'cadastro_analise_preco',
        label: 'Preço das Análises'
    },
    {
        campo: 'cadastro_plano_conta',
        label: 'Plano de Contas'
    },
    {
        campo: 'cadastro_centro_custo',
        label: 'Centro de Custo'
    },
    {
        campo: 'coleta',
        label: 'Coletas'
    },
    {
        campo: 'aplicacao',
        label: 'Aplicações'
    },
    {
        campo: 'abastecimento',
        label: 'Abastecimentos'
    },
    {
        campo: 'manutencao',
        label: 'Manutenções'
    },
    {
        campo: 'brinde_entrada',
        label: 'Brindes - Entrada'
    },
    {
        campo: 'brinde_saida',
        label: 'Brindes - Saída'
    },
    {
        campo: 'brinde_estoque',
        label: 'Brindes - Estoque'
    },
    {
        campo: 'conta_pagar',
        label: 'Contas a Pagar'
    },
    {
        campo: 'conta_receber',
        label: 'Contas a Receber'
    },
    {
        campo: 'dre',
        label: 'DRE'
    },
    {
        campo: 'agenda',
        label: 'Agenda'
    },
    {
        campo: 'conta_corrente',
        label: 'Conta Corrente de Funcionários'
    },
    {
        campo: 'ferramentas',
        label: 'Ferramentas Operacionais'
    }
];

let UsuarioPerfilForm = props => {

    const formulario = props.formularioValues || {};
    const readOnly = props.excluir ? 'readOnly' : '';

    const alterarPermissao = (campo, valor) => {
        props.initForm({
            ...formulario,
            [campo]: valor ? valor.split(',') : []
        });
    };

    return (
        <ContentCard>
            <Form event={props.handleSubmit}>
                <ContentCardBody>

                    <Row>
                        <Field
                            name='nome'
                            component={LabelAndInput}
                            label='Nome *'
                            placeholder='Informe o nome'
                            cols='12 12 12 12'
                            readOnly={readOnly}
                        />
                    </Row>

                    <Row>
                        {permissoesCadastro.map(item => (
                            <Select
                                key={item.campo}
                                name={item.campo}
                                options={
                                    [
                                        'brinde_estoque',
                                        'dre'
                                    ].includes(item.campo)
                                        ? listaSomenteVisualizacao
                                        : listaPermissaoCadastro
                                }
                                label={item.label}
                                cols='12 12 4 4'
                                placeholder='Selecione'
                                readOnly={readOnly}
                                value={(formulario[item.campo] || []).join(',')}
                                onChange={valor => alterarPermissao(item.campo, valor)}
                            />
                        ))}
                    </Row>

                </ContentCardBody>

                <ContentCardFooter>
                    <Row alignCenter>
                        <Grid cols='6 6 4 3'>
                            <Button
                                text='Voltar'
                                type='light'
                                icon='fa fa-chevron-left'
                                event={() => props.setModoTela('lista')}
                            />
                        </Grid>

                        <Grid cols='6 6 4 3'>
                            {props.excluir &&
                                <Button
                                    text='Excluir'
                                    submit
                                    type='danger'
                                    icon='fa fa-trash'
                                />}

                            {!props.excluir &&
                                <Button
                                    text='Salvar'
                                    submit
                                    type='success'
                                    icon='fa fa-check'
                                />}
                        </Grid>
                    </Row>
                </ContentCardFooter>
            </Form>
        </ContentCard>
    );
};

UsuarioPerfilForm = reduxForm({
    form: 'usuarioPerfilForm',
    destroyOnUnmount: false
})(UsuarioPerfilForm);

const mapStateToProps = state => ({
    sessao: state.auth.usuario,
    formularioValues: getFormValues('usuarioPerfilForm')(state),
    registro: state.usuarioPerfil.registro
});

const mapDispatchToProps = dispatch => bindActionCreators({
    setModoTela,
    initForm
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(UsuarioPerfilForm);
